module.exports = __webpack_public_path__ + "static/media/van1000.de55d75f.svg";